import { customElement } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import Slider from '../../slider';
import './product-gallery.css';
import './product-gallery-video';
import './product-zoom-modal';

@customElement('product-media-gallery')
class ProductMediaGallery extends LitElement {
  initializeComponent() {
    this.sliderEl = this.querySelector('[data-product-media-gallery-carousel]');
    this.slider = null;
    this.seeMoreButton = this.querySelector('[data-gallery-see-more-button]');
    this.desktopMediaItems = this.querySelectorAll('[data-desktop-media-item]');
    this.zoomButtons = this.querySelectorAll('[data-zoom-button]');
    this.zoomModal = this.querySelector('product-zoom-modal');
    this.replacementTargetSelector = '[data-gallery-replacement-target]';

    this.seeMoreButton?.addEventListener(
      'click',
      this._handleSeeMoreButtonClick,
    );

    this.zoomButtons.forEach((button) => {
      button.addEventListener('click', this._handleZoomButtonClick);
    });

    this._handleSwiperClickHandler();
    this._initSlider();
  }

  connectedCallback() {
    super.connectedCallback();
    this.initializeComponent();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._cleanupComponent();
  }

  _cleanupComponent() {
    this.slider.unload();
    this.seeMoreButton?.removeEventListener(
      'click',
      this._handleSeeMoreButtonClick,
    );
    this.zoomButtons.forEach((button) => {
      button.removeEventListener('click', this._handleZoomButtonClick);
    });
  }

  _handleSwatchUpdate = async (event) => {
    const { product } = event.detail;
    const { handle } = product;
    const dom = this.productColorGrouping[handle];
    const newProductMediaGallery = dom
      .querySelector(this.replacementTargetSelector)
      ?.cloneNode(true);
    this._cleanupComponent();
    if (!newProductMediaGallery) return;
    this.innerHTML = newProductMediaGallery.innerHTML;
    this.initializeComponent();
  };

  _handleZoomButtonClick = (e) => {
    const { target } = e;
    const clickedIndex = Number(target.dataset.currentIndex);

    this.zoomModal.openModal(clickedIndex);
  };

  _handleSeeMoreButtonClick = () => {
    this.seeMoreButton.classList.add('hidden');
    this.desktopMediaItems.forEach((item, index) => {
      item.classList.remove('hidden');
      if (index >= 4) {
        const playButton = item.querySelector('[data-play-button]');
        playButton?.click();
      }
    });
  };

  _handleSwiperClickHandler() {
    document.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.addEventListener('click', () => {
        const playVideoModal = slide.closest('product-zoom-modal');
        if (playVideoModal) {
          const playVideo = playVideoModal.querySelector(
            '[data-product-zoom-gallery-main] [data-play-button]',
          );
          playVideo?.click();
        }
      });
    });
  }

  _initSlider = () => {
    this.slider = new Slider({
      el: this.sliderEl,
      options: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletClass: 'swiper-pagination-bullet h-full flex-grow block',
          bulletActiveClass: 'swiper-pagination-bullet-active bg-gray-800',
        },
        allowTouchMove: true,
        className: 'w-full',
      },
    });
  };

  render() {
    return html`<slot></slot>`;
  }
}

export default ProductMediaGallery;
